import { z } from 'zod';

export const CHECK_OLD_PLACEHOLDERS_SOURCES = { READ_MODEL: 'readModel', SAGA: 'saga' } as const;

export const checkOldPlaceholdersFinding = z.object({
    id: z.string().min(1),
    name: z.string().nullable(),
    path: z.string().min(1),
    placeholder: z.string().min(1),
    preview: z.string().min(1),
    source: z.enum([CHECK_OLD_PLACEHOLDERS_SOURCES.READ_MODEL, CHECK_OLD_PLACEHOLDERS_SOURCES.SAGA]),
});

export const checkOldPlaceholdersResponse = z.object({
    findings: z.array(checkOldPlaceholdersFinding),
    scanned: z.number().int().nonnegative(),
});

export type CheckOldPlaceholdersFinding = z.infer<typeof checkOldPlaceholdersFinding>;
export type CheckOldPlaceholdersResponse = z.infer<typeof checkOldPlaceholdersResponse>;
